var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { config } from 'lib-shared-backend-config';
import { createAuthorizationHeaderValue } from 'utils/apis/axios';
export function isPrivateFilesAPI(filePath) {
    return filePath.includes(`${config.url.files.replace('https://', '').replace('/', '')}/private`);
}
export function getFileHeaders(isPrivateFile) {
    return __awaiter(this, void 0, void 0, function* () {
        return isPrivateFile
            ? {
                Authorization: yield createAuthorizationHeaderValue(),
            }
            : {
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
            };
    });
}
// `/v2/search` does not seem to provide a valid nb_pages value, so calculate on frontend.
export const getNbPages = (result) => {
    const { nb_hits, hits_per_page, nb_pages } = result;
    if (nb_pages !== 0) {
        return nb_pages;
    }
    return Math.ceil(nb_hits / hits_per_page) || nb_pages;
};
